import React from "react";
import { Box, Container } from "@mui/material";
import TrackSection from "../../section/section_track/track_section_main";
import MobileDownloadMainSection from "../../section/section_mobile_download/mobile_download_section_main";


import HomeFirstSection from "./components/home_first_section";
import HomeOfferSection from "./components/home_offer_section";
// import HomeSecondSection from "./components/second_section/home_second_section";
import HomeThirdSection from "./components/home_third_section";
// import ExtraFoodSlider from "../../components/offerSection/extraFood/sliderFood";
import SocialMediaBar from "src/components/social_media_bar/social_media_bar_main";
import "./home.css";
// import Menu from "../menu/components/menu_first_section/menu_first_section";
// import WeServe from "./components/weServe/weServe";
import WeServeMainCourses from "../menu/components/mainCourse/mainCourse";

function HomeView() {
  return (
    <main>
      <SocialMediaBar autoOpenOnLoad />
      {/* first section */}
      <Box component="section">
        <HomeFirstSection />
      </Box>
      <HomeOfferSection />
      {/* second section */}
      <Box
        component="section"
        id="home-menu"
        sx={{
          scrollMarginTop: 80,
          py: { xs: 0, md: 0.5 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: { xs: 1, sm: 1, lg: 2 },
          }}
        >
          {/* <HomeSecondSection /> */}
          <WeServeMainCourses />
        </Container>
      </Box>
      {/* third section */}
      <Box
        component="section"
        sx={{
          background: "linear-gradient(180deg, #eeede2 0%, #f8f6ed 100%)",
           scrollMarginTop: 80,
          py: { xs: 0, md: 0.5 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: { xs: 0, sm: 2, lg: 2 },
          }}
        >
          <HomeThirdSection />
        </Container>
      </Box>
      {/* forth section/track your order*/}
      <Box
        component="section"
        sx={{
          background: "linear-gradient(180deg, #f8f6ed 0%, #fffdf7 100%)",
         scrollMarginTop: 80,
          // py: { xs: 0, md: 0.5 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: { xs: 2, sm: 4, lg: 5 },
          }}
        >
          <TrackSection />
        </Container>
      </Box>
      {/* promise section */}
      {/* <Box component="section" sx={{ backgroundColor: "#FFFDF7" }}>
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: { xs: 0, sm: 4, lg: 5 },
          }}
        >
          <PromiseSection />
        </Container>
      </Box> */}
      {/* mobile download section */}
      <Box
        component="section"
        sx={{
          background: "linear-gradient(180deg, #fffdf7 0%, #f3f1e6 100%)",
          // py: { xs: 1, md: 3 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: { xs: 0, sm: 4, lg: 2 },
          }}
        >
          <MobileDownloadMainSection />
        </Container>
      </Box>

    </main>
  );
}

export default HomeView;
